import type { MouseEvent } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import type { ChartView } from '../districtStatsChart';
import { DASH } from '../tokens';

export const CHART_VIEW_OPTIONS: ReadonlyArray<{ value: ChartView; label: string }> = [
  { value: 'ml', label: 'Active ML students' },
  { value: 'fl', label: 'Flashlight360 students' },
];

const BUTTON_SX = {
  padding: '4px 12px',
  border: 0,
  borderRadius: 0,
  color: DASH.muted,
  fontFamily: 'inherit',
  fontSize: 12,
  lineHeight: '24px',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': { bgcolor: DASH.stats.hover },
  '& + &': { borderLeft: `1px solid ${DASH.rowBorder}` },
  '&.Mui-selected': { bgcolor: DASH.stats.toggleOn, color: DASH.ghost, fontWeight: 700 },
  '&.Mui-selected:hover': { bgcolor: DASH.stats.toggleOn },
} as const;

export function ChartViewToggle({ view, onChange }: { view: ChartView; onChange: (view: ChartView) => void }) {
  const handleChange = (_event: MouseEvent<HTMLElement>, next: ChartView | null) => {
    if (next !== null) onChange(next);
  };
  return (
    <ToggleButtonGroup
      exclusive
      value={view}
      onChange={handleChange}
      aria-label="Chart view"
      sx={{
        border: `1px solid ${DASH.rowBorder}`,
        borderRadius: '8px',
        overflow: 'hidden',
        bgcolor: DASH.cardBg,
        '& .MuiToggleButtonGroup-grouped': { border: 0, borderRadius: 0, margin: 0 },
      }}
    >
      {CHART_VIEW_OPTIONS.map((option) => (
        <ToggleButton key={option.value} value={option.value} disableRipple sx={BUTTON_SX}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
